import { Component, ElementRef, ViewChild } from '@angular/core';
import { BaseModalComponent } from '../base-modal/base-modal.component';
import { EmailTemplateBaseModel } from 'src/app/core/models/emailTemplates/email-template.model.ts';
import { result } from 'lodash';

@Component({
  selector: 'app-email-template-modal',
  templateUrl: './email-template-modal.component.html',
  styleUrls: ['./email-template-modal.component.scss']
})
export class EmailTemplateModalComponent extends BaseModalComponent {

  public override model: EmailTemplateBaseModel = new EmailTemplateBaseModel;
  textTypeIsRaw: boolean = false;

  override onUpdate(): void {

    this.myFileApiService.updateEmailTemplate(this.model).subscribe(result => {
      if (result) {
        this.toasterNotificationService.showSuccess($localize`:@@:Email Template updated successfully`, $localize`:@@Toast_Success_GeneralTitle:Success`);
        this.modalRef.close();
      }
    })

  }

  override onCreate(): void {
    this.myFileApiService.createEmailTemplate(this.model).subscribe(result => {
      if (result) {
        this.toasterNotificationService.showSuccess($localize`:@@:Email Template created successfully`, $localize`:@@Toast_Success_GeneralTitle:Success`);
        this.modalRef.close();
      }
    })
  }

  updateText(event: any) {
    this.model.content = event;
  }

  onDelete(): void {
    if (this.model.id) {
      this.myFileApiService.deleteEmailTemplate(this.model.id).subscribe(result => {
        if (result) {
          this.toasterNotificationService.showSuccess($localize`:@@:Email Template deleted successfully`, $localize`:@@Toast_Success_GeneralTitle:Success`);
          this.modalRef.close();
        }
      })
    }
  }

  sanitize(text: string) {
    if (text) {
      return this.sanitizer.bypassSecurityTrustHtml(text);
    }
    return ' '
  }

  //not required
  override ngOnInit(): void {
  }

  override ngOnDestroy(): void {
  }

  override validate(): boolean {
    return true;
  }

}



